import { Col, Row, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export function PersonalMemos({ person, handleOtherDetails, isPersonal }) {
  const { t } = useTranslation();

  return <>
    {!isPersonal &&
    <Row>
      <Form.Group as={Col} xl={12} className="position-relative" controlId="memoHR">
        <Form.Label>{t("MemoHR", "Muistio HR sisäinen")}</Form.Label>
        <Form.Control as="textarea" rows={3} defaultValue={person.otherDetails?.memoHR ?? ""} onChange={handleOtherDetails} className="memobackground" />
      </Form.Group>
    </Row>
    }
    {!isPersonal &&
    <Row>
      <Form.Group as={Col} xl={12} className="position-relative" controlId="memoSalary">
        <Form.Label>{t("MemoSalary", "Muistio palkanlaskentaan")}</Form.Label>
        <Form.Control as="textarea" rows={3} defaultValue={person.otherDetails?.memoSalary ?? ""} onChange={handleOtherDetails} />
      </Form.Group>
    </Row>
    }
    <Row>
      <Form.Group as={Col} xl={12} className="position-relative" controlId="memoEmployee">
        <Form.Label>{t("MemoEmployee", "Muistio työntekijälle")}</Form.Label>
        <Form.Control as="textarea" rows={3} defaultValue={person.otherDetails?.memoEmployee ?? ""} onChange={handleOtherDetails} />
      </Form.Group>
    </Row>
    {!isPersonal &&
    <Row>
      <Form.Group as={Col} xl={12} className="position-relative" controlId="memoSupervisor">
        <Form.Label>{t("MemoSupervisor", "Muistio esihenkilölle")}</Form.Label>
        <Form.Control as="textarea" rows={3} defaultValue={person.otherDetails?.memoSupervisor ?? ""} onChange={handleOtherDetails} />
      </Form.Group>
    </Row>
    }
  </>;
}
